import React from "react";

import AttendanceMonthToolbar from "./AttendanceMonthToolbar";
import AttendanceMonthlyKpiCards from "./AttendanceMonthlyKpiCards";
import AttendanceMonthlyLegend from "./AttendanceMonthlyLegend";
import AttendanceMonthlyHeatmapTable from "./AttendanceMonthlyHeatmapTable";
import AttendanceMonthlyMobileCards from "./AttendanceMonthlyMobileCards";

export default function AttendanceMonthlySection({
  selectedGroup,
  selectedMonth,
  rows = [],
  kpis = {},
  highlightIds = [],
  loading = false,
  savingCells = new Set(),
  onSelectMonth,
  onToggleCell,
  onRefresh,
}) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="h-1.5 bg-gradient-to-r from-blue-700 via-sky-500 to-emerald-500" />

      <div className="p-4 sm:p-5">
        <AttendanceMonthToolbar
          selectedGroup={selectedGroup}
          selectedMonth={selectedMonth}
          loading={loading}
          onSelectMonth={onSelectMonth}
          onRefresh={onRefresh}
        />

        <div className="mt-5">
          <AttendanceMonthlyKpiCards
            kpis={kpis}
            adherentsCount={rows.length}
            loading={loading}
          />
        </div>

        <div className="mt-6 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
              Tableau mensuel
            </p>

            <h2 className="mt-1 font-titre text-xl font-bold text-slate-950 dark:text-white">
              Présences et absences du mois
            </h2>

            <p className="mt-2 max-w-3xl text-sm font-medium leading-6 text-slate-500 dark:text-slate-400">
              Cliquez une case pour basculer : non saisi → présent → absent →
              non saisi. La mise à jour est immédiate.
            </p>
          </div>

          <AttendanceMonthlyLegend />
        </div>

        {loading ? (
          <div className="mt-5 space-y-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="h-16 animate-pulse rounded-2xl border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-800/60"
              />
            ))}
          </div>
        ) : rows.length === 0 ? (
          <div className="mt-5 rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-10 text-center dark:border-slate-700 dark:bg-slate-800/40">
            <h3 className="text-base font-bold text-slate-900 dark:text-white">
              Aucun résultat à afficher
            </h3>

            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              Sélectionnez un mois ou vérifiez que le groupe contient bien des
              judokas.
            </p>
          </div>
        ) : (
          <div className="mt-5">
            <AttendanceMonthlyHeatmapTable
              month={selectedMonth}
              rows={rows}
              highlightIds={highlightIds}
              savingCells={savingCells}
              onToggleCell={onToggleCell}
            />

            <AttendanceMonthlyMobileCards
              month={selectedMonth}
              rows={rows}
              highlightIds={highlightIds}
              savingCells={savingCells}
              onToggleCell={onToggleCell}
            />
          </div>
        )}
      </div>
    </section>
  );
}